import VSelectCardTicketType from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCardTicketType', VSelectCardTicketType),
};
